(function () {
  'use strict';
  if (window.thRoundedDropdowns) return;
  window.thRoundedDropdowns = true;
  var configNode = document.getElementById('th-dropdown-config');
  if (!configNode) return;
  var strings = JSON.parse(configNode.textContent);
  var controls = new Map();
  var pickers = new Map();
  var sequence = 0;
  var openControl = null;
  var scanPending = false;
  var typeBuffer = '';
  var typeTimer;
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function optionLabel(name) {
    if (/pack|count/i.test(name)) return strings.pack_size;
    if (/strength|formulation/i.test(name)) return strings.formula_strength;
    if (/scent|fragrance/i.test(name)) return strings.scent;
    if (/^size$/i.test(name)) return strings.size;
    return name === 'Title' ? strings.choose_option : name;
  }
  function resolveVariant(variants, wanted, changedIndex) {
    var candidates = variants.filter(function (variant) {
      return wanted.every(function (value, index) { return index > changedIndex || variant.options[index] === value; });
    });
    var exact = candidates.find(function (variant) { return variant.options.every(function (value, index) { return wanted[index] === value; }); });
    if (exact) return exact;
    var available = candidates.filter(function (variant) { return variant.available; });
    var pool = available.length ? available : candidates;
    var best;
    var bestScore = -1;
    pool.forEach(function (variant) {
      var score = variant.options.reduce(function (sum, value, index) { return sum + (index > changedIndex && wanted[index] === value ? 1 : 0); }, 0);
      if (score > bestScore) { best = variant; bestScore = score; }
    });
    return best;
  }
  function setPicker(picker, variant) {
    if (!variant) return;
    picker.selects.forEach(function (select, index) {
      select.replaceChildren();
      picker.values[index].forEach(function (value) {
        var matches = picker.data.variants.filter(function (candidate) {
          return candidate.options[index] === value && candidate.options.every(function (other, before) {
            return before >= index || other === variant.options[before];
          });
        });
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value + (!matches.length ? ' — ' + strings.unavailable : !matches.some(function (item) { return item.available; }) ? ' — ' + strings.sold_out : '');
        option.disabled = !matches.length;
        option.selected = value === variant.options[index];
        select.append(option);
      });
      select.disabled = picker.source.disabled;
      sync(select);
    });
  }
  function initializePickers() {
    document.querySelectorAll('[data-th-product-card]').forEach(function (card) {
      if (pickers.has(card)) return;
      var source = card.querySelector('[data-th-variant]');
      var json = card.querySelector('[data-th-product]');
      if (!source || !json) return;
      var data;
      try { data = JSON.parse(json.textContent); } catch (_) { return; }
      if (!data.optionNames || !data.optionNames.length || !data.variants.every(function (variant) { return Array.isArray(variant.options) && variant.options.length === data.optionNames.length; })) return;
      var group = el('div', 'th-product-options');
      var status = el('p', 'th-option-status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      var picker = {source:source, data:data, selects:[], values:[], status:status};
      data.optionNames.forEach(function (name, index) {
        var field = el('div', 'th-option-field');
        var select = document.createElement('select');
        select.id = 'th-option-' + (++sequence);
        select.className = 'th-option-select';
        select.dataset.thOption = String(index);
        var label = el('label', 'th-option-label', optionLabel(name));
        label.htmlFor = select.id;
        picker.values.push(Array.from(new Set(data.variants.map(function (variant) { return variant.options[index]; }))));
        picker.selects.push(select);
        field.append(label, select);
        group.append(field);
        select.addEventListener('change', function () {
          if (source.disabled) return;
          var wanted = picker.selects.map(function (control) { return control.value; });
          var variant = resolveVariant(data.variants, wanted, index);
          if (!variant) return;
          source.value = String(variant.id);
          setPicker(picker, variant);
          source.dispatchEvent(new Event('change', {bubbles:true}));
          var adjusted = variant.options.some(function (value, position) { return value !== wanted[position]; });
          status.textContent = adjusted ? strings.selection_updated.replace('{selection}', variant.options.join(' / ')) : '';
        });
      });
      group.append(status);
      var fallback = source.closest('[data-th-variant-fallback]');
      if (!fallback) return;
      fallback.before(group);
      fallback.hidden = true;
      source.dataset.thDropdownIgnore = '';
      pickers.set(card, picker);
      setPicker(picker, data.variants.find(function (variant) { return String(variant.id) === source.value; }));
      source.addEventListener('change', function () {
        setPicker(picker, data.variants.find(function (variant) { return String(variant.id) === source.value; }));
      });
      new MutationObserver(function () {
        picker.selects.forEach(function (select) { select.disabled = source.disabled; sync(select); });
      }).observe(source, {attributes:true, attributeFilter:['disabled']});
    });
  }
  function closeMenu(restoreFocus) {
    if (!openControl) return;
    var control = openControl;
    openControl = null;
    control.button.setAttribute('aria-expanded', 'false');
    control.button.removeAttribute('aria-activedescendant');
    control.menu.remove();
    control.menu = null;
    if (restoreFocus && control.button.isConnected) control.button.focus({preventScroll:true});
  }
  function enabledIndices(control) {
    return Array.from(control.select.options).reduce(function (indices, option, index) {
      if (!option.disabled && !option.hidden && !(option.parentElement.tagName === 'OPTGROUP' && option.parentElement.disabled)) indices.push(index);
      return indices;
    }, []);
  }
  function activate(control, index) {
    if (!control.menu || index < 0) return;
    control.active = index;
    control.menu.querySelectorAll('[role="option"]').forEach(function (option) {
      option.classList.toggle('is-active', Number(option.dataset.index) === index);
    });
    var active = control.menu.querySelector('[data-index="' + index + '"]');
    if (active) {
      control.button.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({block:'nearest'});
    }
  }
  function positionMenu() {
    if (!openControl || !openControl.menu) return;
    var control = openControl;
    var rect = control.button.getBoundingClientRect();
    var viewport = window.visualViewport;
    var leftEdge = viewport ? viewport.offsetLeft : 0;
    var topEdge = viewport ? viewport.offsetTop : 0;
    var width = viewport ? viewport.width : window.innerWidth;
    var height = viewport ? viewport.height : window.innerHeight;
    if (rect.bottom < topEdge || rect.top > topEdge + height) { closeMenu(false); return; }
    var menu = control.menu;
    var menuWidth = Math.min(Math.max(rect.width, 220), width - 24);
    menu.style.width = menuWidth + 'px';
    menu.style.left = Math.max(leftEdge + 12, Math.min(rect.left, leftEdge + width - menuWidth - 12)) + 'px';
    var below = topEdge + height - rect.bottom - 18;
    var above = rect.top - topEdge - 18;
    var flip = below < 200 && above > below;
    menu.style.maxHeight = Math.max(80, Math.min(320, flip ? above : below)) + 'px';
    menu.style.top = (flip ? Math.max(topEdge + 12, rect.top - menu.offsetHeight - 7) : rect.bottom + 7) + 'px';
  }
  function choose(control, index) {
    if (control.select.disabled || enabledIndices(control).indexOf(index) === -1) return;
    var changed = control.select.selectedIndex !== index;
    control.select.selectedIndex = index;
    closeMenu(true);
    sync(control.select);
    if (changed) {
      control.select.dispatchEvent(new Event('input', {bubbles:true}));
      control.select.dispatchEvent(new Event('change', {bubbles:true}));
    }
  }
  function openMenu(control, fromEnd) {
    if (control.select.disabled) return;
    if (openControl === control) return;
    closeMenu(false);
    var menu = el('div', 'th-dropdown-menu');
    menu.id = control.menuId;
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-label', control.label);
    var previousGroup = null;
    Array.from(control.select.options).forEach(function (option, index) {
      if (option.hidden) return;
      var group = option.parentElement.tagName === 'OPTGROUP' ? option.parentElement : null;
      if (group && group !== previousGroup) menu.append(el('div', 'th-dropdown-group', group.label));
      previousGroup = group;
      var item = el('div', 'th-dropdown-option');
      item.id = control.menuId + '-' + index;
      item.dataset.index = String(index);
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', String(option.selected));
      var disabled = option.disabled || Boolean(group && group.disabled);
      item.setAttribute('aria-disabled', String(disabled));
      item.classList.toggle('is-selected', option.selected);
      item.append(el('span', 'th-dropdown-option-text', option.label));
      var check = el('span', 'th-dropdown-check', option.selected ? '✓' : '');
      check.setAttribute('aria-hidden', 'true');
      item.append(check);
      item.addEventListener('pointerdown', function (event) { event.preventDefault(); });
      item.addEventListener('click', function () { choose(control, index); });
      item.addEventListener('pointermove', function (event) { if (!disabled && event.pointerType !== 'touch') activate(control, index); });
      menu.append(item);
    });
    control.menu = menu;
    openControl = control;
    control.button.setAttribute('aria-expanded', 'true');
    var dialog = control.button.closest('dialog[open]');
    (dialog || document.body).append(menu);
    positionMenu();
    var enabled = enabledIndices(control);
    var selected = control.select.selectedIndex;
    activate(control, enabled.indexOf(selected) >= 0 ? selected : fromEnd ? enabled[enabled.length - 1] : enabled[0]);
  }
  function sync(select) {
    var control = controls.get(select);
    if (!control) return;
    var option = select.options[select.selectedIndex];
    control.value.textContent = option ? option.label : strings.choose_option;
    control.button.disabled = select.disabled || Boolean(select.closest('fieldset[disabled]'));
    control.button.setAttribute('aria-required', String(select.required));
    control.button.setAttribute('aria-invalid', String(select.getAttribute('aria-invalid') === 'true'));
    if (openControl === control) closeMenu(false);
  }
  function enhance(select) {
    if (controls.has(select) || select.multiple || select.size > 1 || select.hidden || select.hasAttribute('data-th-dropdown-ignore') || select.closest('noscript,[hidden],[data-th-dropdown-ignore]') || !select.getClientRects().length || getComputedStyle(select).visibility === 'hidden') return;
    var wrapper = el('div', 'th-dropdown');
    var button = el('button', 'th-dropdown-trigger');
    var value = el('span', 'th-dropdown-value');
    var caret = el('span', 'th-dropdown-caret');
    caret.setAttribute('aria-hidden', 'true');
    var labels = Array.from(select.labels || []);
    var label = select.getAttribute('aria-label') || labels.map(function (item) { return item.textContent.trim(); }).join(' ') || strings.choose_option;
    var id = 'th-dropdown-' + (++sequence);
    button.type = 'button';
    button.setAttribute('role', 'combobox');
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', id + '-menu');
    var labelIds = labels.map(function (item) {
      if (!item.id) item.id = id + '-label-' + (++sequence);
      item.addEventListener('click', function (event) { event.preventDefault(); button.focus(); });
      return item.id;
    });
    if (select.getAttribute('aria-labelledby')) button.setAttribute('aria-labelledby', select.getAttribute('aria-labelledby'));
    else if (labelIds.length) button.setAttribute('aria-labelledby', labelIds.join(' '));
    else button.setAttribute('aria-label', label);
    if (select.getAttribute('aria-describedby')) button.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
    button.append(value, caret);
    var parent = select.parentElement;
    select.before(wrapper);
    wrapper.append(select, button);
    select.classList.add('th-dropdown-native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    if (parent.classList.contains('select')) parent.classList.add('th-dropdown-host');
    var control = {select:select, button:button, wrapper:wrapper, value:value, menuId:id + '-menu', label:label, active:-1, menu:null};
    controls.set(select, control);
    sync(select);
    button.addEventListener('click', function () { if (openControl === control) closeMenu(false); else openMenu(control); });
    button.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key === 'Tab') { closeMenu(false); return; }
      if (key === 'Escape' && openControl === control) { event.preventDefault(); event.stopPropagation(); closeMenu(true); return; }
      if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        if (openControl === control) choose(control, control.active); else openMenu(control);
        return;
      }
      if (['ArrowDown','ArrowUp','Home','End'].indexOf(key) !== -1) {
        event.preventDefault();
        var wasOpen = openControl === control;
        openMenu(control, key === 'ArrowUp');
        var enabled = enabledIndices(control);
        var position = enabled.indexOf(control.active);
        if (key === 'Home') position = 0;
        else if (key === 'End') position = enabled.length - 1;
        else if (wasOpen) position = Math.max(0, Math.min(enabled.length - 1, position + (key === 'ArrowDown' ? 1 : -1)));
        activate(control, enabled[position]);
        return;
      }
      if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        event.preventDefault();
        clearTimeout(typeTimer);
        typeBuffer += key.toLocaleLowerCase();
        typeTimer = setTimeout(function () { typeBuffer = ''; }, 600);
        openMenu(control);
        var match = enabledIndices(control).find(function (index) { return control.select.options[index].label.toLocaleLowerCase().startsWith(typeBuffer); });
        if (match !== undefined) activate(control, match);
      }
    });
    select.addEventListener('change', function () { sync(select); });
    select.addEventListener('invalid', function (event) { event.preventDefault(); button.setAttribute('aria-invalid', 'true'); button.focus(); });
    new MutationObserver(function () { sync(select); }).observe(select, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['disabled','selected','label','value','aria-invalid','required']});
    if (select.form) select.form.addEventListener('reset', function () { setTimeout(function () { sync(select); }, 0); });
  }
  function scan() {
    scanPending = false;
    initializePickers();
    document.querySelectorAll('select').forEach(enhance);
    controls.forEach(function (control, select) {
      if (!select.isConnected) {
        if (openControl === control) closeMenu(false);
        controls.delete(select);
      }
    });
    pickers.forEach(function (_, card) { if (!card.isConnected) pickers.delete(card); });
  }
  function scheduleScan() {
    if (scanPending) return;
    scanPending = true;
    requestAnimationFrame(scan);
  }
  document.addEventListener('pointerdown', function (event) {
    if (openControl && !openControl.wrapper.contains(event.target) && !openControl.menu.contains(event.target)) closeMenu(false);
  }, true);
  document.addEventListener('focusin', function (event) {
    if (openControl && event.target !== openControl.button && !openControl.menu.contains(event.target)) closeMenu(false);
  });
  document.addEventListener('change', function () {
    controls.forEach(function (_, select) { sync(select); });
    scheduleScan();
  });
  document.addEventListener('shopify:section:load', scheduleScan);
  window.addEventListener('resize', positionMenu, {passive:true});
  document.addEventListener('scroll', positionMenu, {passive:true,capture:true});
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', positionMenu, {passive:true});
    window.visualViewport.addEventListener('scroll', positionMenu, {passive:true});
  }
  new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      if (mutation.type === 'attributes') return mutation.target.tagName !== 'OPTION';
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && !node.closest('.th-dropdown,.th-dropdown-menu') && (node.matches('select,[data-th-product-card]') || node.querySelector('select,[data-th-product-card]'));
      });
    });
    if (relevant) scheduleScan();
  }).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
  scan();
})();